import { render } from "./role.vue?vue&type=template&id=61f8fedc&scoped=true&ts=true"
import script from "./role.vue?vue&type=script&lang=ts"
export * from "./role.vue?vue&type=script&lang=ts"

import "./role.vue?vue&type=style&index=0&id=61f8fedc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f8fedc"]])

export default __exports__